import {
    GET_CARDS_REQUEST,
    GET_CARDS_SUCCESS,
    SEARCH_CARDS_REQUEST,
    SEARCH_CARDS_SUCCESS,
    SAVE_CARD_REQUEST,
    SAVE_CARD_SUCCESS,
    SAVE_CARD_TEMPORARILY,
    ADD_CARD_REQUEST,
    ADD_CARD_SUCCESS,
    EDIT_CARD_REQUEST,
    EDIT_CARD_SUCCESS,
    EDIT_CARD_TIME_PERIOD,
    DELETE_CARD_REQUEST,
    DELETE_CARD_SUCCESS,
    SAVE_CARD_FAIL,
    DELETE_CARD_FAIL,
    CLEAR_PAGE_REQUEST,
    CLEAR_PAGE_SUCCESS
} from '../constants/Cards'
import {sessionService} from 'redux-react-session';


// import cardsJson from '../../data/cards.json';


let getCardsAction = function (dispatch, companyId) {
  let searchInput, status;

  dispatch({
      type: GET_CARDS_REQUEST,
      payload: ''
  });

//   return Promise.resolve(cardsJson)
//     .then((cards) => {
//         cards = cards.filter(bySearchInput).filter(byStatus);
//         dispatch({
//             type: GET_CARDS_SUCCESS,
//             payload: cards
//         });
//     });

  sessionService.loadSession()
    .then(currentSession => {

      var url = BASE_URL + 'getCards/' + (companyId ? companyId : '');
      var params = {
        method: 'GET',
        headers: {'X-Session-Id': currentSession.sessionId}
      };

      searchInput = currentSession.searchInput;
      status = currentSession.status;

      fetch(url, params)
        .then(response => response.json(), error => console.log(error))
        .then(json => {
          if (json.error) {
            console.log(json.error);
          } else {
            let cards = json.cards;
            if (cards) {

              cards = cards.filter(bySearchInput).filter(byStatus);

              dispatch({
                  type: GET_CARDS_SUCCESS,
                  payload: cards
              });

            }
          }
        });

    });

    function bySearchInput(card) {

      if (!searchInput || !searchInput.trim()) {
        return true;
      }

      let found = true;
      const keywords = searchInput.split(' ');

      for (const keyword of keywords) {
          const regexp = new RegExp(keyword, 'i');
          if (card.firstName.search(regexp) === -1 &&
              card.lastName.search(regexp) === -1 &&
              (companyId || card.companyName.search(regexp) === -1)) {
            found = false;
          }
      }

      return found;

    }

    function byStatus(card) {
      if (!status) {
        return true;
      }
      return status === card.status;
    }
};

export function getCards(companyId, searchInput = '', status = '') {
    return (dispatch) => {
        getCardsAction(dispatch, companyId, searchInput, status);
    };
}

export function searchCards(text = '') {
    return (dispatch) => {
        dispatch({
            type: SEARCH_CARDS_REQUEST,
            payload: ''
        });

        setTimeout(() => {
            dispatch({
                type: SEARCH_CARDS_SUCCESS,
                payload: text
            })
        }, 1000)
    };
}

export function saveCard(card, companyId) {
    return (dispatch) => {
        dispatch({
            type: SAVE_CARD_REQUEST,
            payload: ''
        });

        return sessionService.loadSession()
          .then(currentSession => {

            return fetch(BASE_URL + 'saveCard/', {
                method: 'POST',
                body: JSON.stringify(card),
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'X-Session-Id': currentSession.sessionId
                }
            })
                .then(response => response.json(), error => console.log(error))
                .then((json) => {
                    if (json.error) {
                        console.log(json.error);
                        return SAVE_CARD_FAIL;
                    } else {
                        const card = json.card;
                        dispatch({
                            type: SAVE_CARD_SUCCESS,
                            payload: card
                        });
                        return SAVE_CARD_SUCCESS;
                    }
                })
                .then(type => {
                    if (type === SAVE_CARD_SUCCESS) {
                        getCardsAction(dispatch, companyId);
                    }
                })
          });

    }
}

export function addCard(e) {
    return (dispatch) => {
        dispatch({
            type: ADD_CARD_REQUEST,
            payload: e
        });

        setTimeout(() => {
            dispatch({
                type: ADD_CARD_SUCCESS,
                payload: e
            })
        }, 1000)
    }
}

export function editCard(e) {
    return (dispatch) => {
        dispatch({
            type: EDIT_CARD_REQUEST,
            payload: e
        });

        setTimeout(() => {
            dispatch({
                type: EDIT_CARD_SUCCESS,
                payload: e
            })
        }, 1000)
    }
}

export function editCardTimePeriod(hasFixedTimePeriod) {
    return (dispatch) => {
        dispatch({
            type: EDIT_CARD_TIME_PERIOD,
            payload: hasFixedTimePeriod
        });
    }
}

export function deleteCard(cardId, companyId) {
    return (dispatch) => {
        dispatch({
            type: DELETE_CARD_REQUEST,
            payload: ''
        });

        return sessionService.loadSession()
            .then(currentSession => {
                return fetch(BASE_URL + cardId, {
                    method: 'DELETE',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'X-Session-Id': currentSession.sessionId,
                    },
                })
                .then(json => {
                    if (json.error) {
                        console.log(json.error);
                        return DELETE_CARD_FAIL;
                    } else {
                        dispatch({
                            type: DELETE_CARD_SUCCESS,
                            payload: cardId
                        });
                        return DELETE_CARD_SUCCESS;
                    }
                })
                .then(type => {
                    if (type === DELETE_CARD_SUCCESS) {
                        getCardsAction(dispatch, companyId);
                    }
                })
                .catch(() => {
                    dispatch({
                        type: DELETE_CARD_FAIL,
                    });
                    throw '';
                });
            });

        // return new Promise((res, reject) => {
        //     setTimeout(() => res({ cardId }), 2000)
        // })
        //     // .then(response => response.json(), error => console.log(error))
        //     .then(json => {
        //         if (json.error) {
        //             console.log(json.error);
        //             return DELETE_CARD_FAIL;
        //         } else {
        //             const cardId = json.cardId;
        //             dispatch({
        //                 type: DELETE_CARD_SUCCESS,
        //                 payload: cardId
        //             });
        //             return DELETE_CARD_SUCCESS;
        //         }
        //     })
        //     .then(type => {
        //         if (type === DELETE_CARD_SUCCESS) {
        //             // getCardsAction(dispatch, companyId);
        //             dispatch({
        //                 type: GET_CARDS_SUCCESS,
        //                 payload: cardsJson.filter(card => card.id !== cardId)
        //             });
        //         }
        //     })
        //     .catch(() => {
        //         dispatch({
        //             type: DELETE_CARD_FAIL,
        //         });
        //         throw '';
        //     })
    }
}

export function saveCardTemporarily(card) {
  return (dispatch) => {
    dispatch({
      type: SAVE_CARD_TEMPORARILY,
      payload: card
    });
  }
}

export function clearPage() {
    return (dispatch) => {
        dispatch({
            type: CLEAR_PAGE_REQUEST
        });

        dispatch({
            type: CLEAR_PAGE_SUCCESS,
            payload: []
        })
    }
}



// WEBPACK FOOTER //
// ./src/actions/CardsActions.js